import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import CustomerGateway from '~apis/customer';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { CustomerAccStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import { PayloadAction } from '@reduxjs/toolkit';
import { TGetCustomerHoldingReduxParams } from '~types/feat/customer';

export default function* watchGetCustomerHoldingsListing(api: CustomerGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerGetCustomerHoldingsListingAttempt', handleGetCustomerHoldingsListing, api);
}

function* handleGetCustomerHoldingsListing(api: CustomerGateway, action: PayloadAction<TGetCustomerHoldingReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { customerId, metalType } = action.payload;

    const response = yield* call([api, api.getCustomerHoldingsListing], {
        authToken,
        customerId,
        metalType
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerGetCustomerHoldingsListingFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.customerGetCustomerHoldingsListingSuccess(response.data));
    }
}
